// Single source of truth for all grading types.
// Must stay in sync with server lib/constants.js.
export const GRADING_TYPES = [
    { value: 'wc_high', label: 'Writing Competition (High)' },
    { value: 'apush_frq', label: 'APUSH FRQ' },
    { value: 'middle_science_frq', label: 'Middle Science FRQ' },
];

// Grading types that return binary is_correct (true/false) instead of score/feedback.
export const BINARY_GRADING_TYPES = ['apush_frq', 'middle_science_frq'];

// Map of grading_type value → display label (for chips, read-only views, etc.)
export const GRADING_TYPE_LABELS = Object.fromEntries(
    GRADING_TYPES.map(({ value, label }) => [value, label])
);

// Single source of truth for all answer tools.
export const ANSWER_TOOLS = [
    { value: 'textfield', label: 'Text Field' },
    { value: 'mathlive', label: 'Mathlive' },
    { value: 'tinymce', label: 'TinyMCE' },
    { value: 'coordinate', label: 'Coordinate Grid' },
    { value: 'table', label: 'Table' },
    { value: 'numberline', label: 'Number Line' },
    { value: 'mapping', label: 'Mapping/Matching' },
    { value: 'polynomialGraph', label: 'Polynomial Graph' },
    { value: 'rationalGraph', label: 'Rational Graph' },
    { value: 'trigGraph', label: 'Trig Graph' },
    { value: 'multiline', label: 'Multiline' },
];
